import { Children, ReactNode } from 'react';

export const childrenToStrings = (children?: ReactNode) => {
    return Children.map<string | undefined, ReactNode>(children, (child: ReactNode) => child?.toString()
        .toLocaleLowerCase());
};